// src/utils/auth.js
export function isAuthenticated() {
    // Example: check for a token in localStorage
    return !!localStorage.getItem('token');
}